export default __webpack_public_path__ + "10809cc7b56d0b4547d769f7be1d2bce.png";